import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify"
import axios from "axios"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MessageBox from '../../../components/CommonComponents/MessageBox'
import { movieOrderDefaultURL } from '../../../components/CommonApis/CommonMovieOrderApi';
import Response_Processing from '../../../layout/Others/Response_Processing'
import { FaEllipsisVertical } from 'react-icons/fa6';
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable';
import { Link } from 'react-router-dom';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { getItemToken } from '../../../Utils/localStorageUtils';
import { IconEditFigma } from '../../../Assets/MyIcons';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';

const MovieSettings = () => {
    const [apiData, setApiData] = useState([]);
    const [enableSetting, setEnableSetting] = useState([])
    const [enableSettingMobile, setEnableSettingMobile] = useState([])
    const [showOverlay, setShowOverlay] = useState(false);
    const [loading, setLoading] = useState(false)
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [option, setOption] = useState('web')

    const HeaderToken = getItemToken('access_token')

    const fetData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${movieOrderDefaultURL?.listApi}`, { headers: HeaderToken })
            const result = response?.data?.Web_Movies_HomePage_Order;
            if (response?.data?.status) {
                setApiData(result)
                setLoading(false)
            }
            else {
                setLoading(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const enableData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${movieOrderDefaultURL?.enableSettingURL}`, { headers: HeaderToken })
            const result = response?.data
            if (response?.data?.status) {
                setEnableSetting(result?.Web_Movies_HomePage_Order)
                setLoading(false)
            }
            else {
                setLoading(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const enableMobileData = async () => {
        try {
            setLoading(true)
            const response = await axios.get(`${movieOrderDefaultURL?.enableSettingMobileURL}`, { headers: HeaderToken })
            const result = response?.data
            if (response?.data?.status) {
                setEnableSettingMobile(result?.Mobile_Movies_HomePage_Order)
                setLoading(false)
            }
            else {
                setLoading(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const handleDragEnd = (result) => {
        if (!result.destination) return;
        const reorderedItems = Array?.from(apiData);
        const [movedItem] = reorderedItems?.splice(result?.source?.index, 1);
        reorderedItems.splice(result?.destination?.index, 0, movedItem);
        setApiData(reorderedItems);
        saveShuffleOrder(reorderedItems);
    };

    const saveShuffleOrder = async (updatedItems) => {
        setShowOverlay(true);
        if (!updatedItems || updatedItems?.length == 0) {
            console.error("Menu items are empty");
            return;
        }
        const positions = updatedItems?.map((menuItem) => menuItem?.id);
        const ids = updatedItems?.map((_, index) => index + 1);

        const requestData = {
            id: positions,
            position: ids,
        };

        try {
            const response = await axios.post(`${movieOrderDefaultURL?.orderApi}`, requestData, { headers: HeaderToken });
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    };

    const handleToggleSettings = async (name, value) => {
        const updatedSetting = enableSetting.map((item) => item?.name === name ? { ...item, Web_HomePage_status: value ? 0 : 1 } : item);
        setEnableSetting(updatedSetting)
    }

    const handleToggleSettingsMobile = async (name, value) => {
        const updatedSetting = enableSettingMobile.map((item) => item?.name === name ? { ...item, Mobile_Homesetting_status: value ? 0 : 1 } : item);
        setEnableSettingMobile(updatedSetting)
    }

    const updateSetting = async () => {
        setShowOverlay(true);

        try {
            // Prepare form data in URL encoded format
            const formData = new URLSearchParams();

            enableSetting?.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Web_HomePage_status, 10)) ? 0 : parseInt(item?.Web_HomePage_status, 10);
                formData.append(item?.name, status); // Append each key-value pair
            });

            // Send POST request with URL-encoded data
            const response = await axios.post(
                `${movieOrderDefaultURL?.updateSettingURL}`,
                formData,
                {
                    headers: {
                        ...HeaderToken,
                        'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                    }
                }
            );

            const result = response.data;

            if (result?.status) {
                toast.success(result?.message);
                setWithOutRefresh(!withOutRefresh);
            } else {
                toast.error(result?.message);
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.message || "An error occurred. Please try again.";
            toast.error(errorMessage);
        } finally {
            setShowOverlay(false);
        }
    };



    const updateSettingMobile = async () => {
        setShowOverlay(true)
        try {
            const formData = new URLSearchParams();
            enableSettingMobile.forEach((item) => {
                const status = Number.isNaN(parseInt(item?.Audio_HomePage_status, 10)) ? 0 : parseInt(item?.Audio_HomePage_status, 10);
                formData.append(item?.name, status);
            });
            const response = await axios.post(`${movieOrderDefaultURL?.updateSettingURL}`, formData,
                {
                    headers: {
                        ...HeaderToken,
                        'Content-Type': 'application/x-www-form-urlencoded' // Specify the content type
                    }
                }
            );
            const result = response.data;
            if (result?.status) {
                toast.success(result?.message);
                setShowOverlay(false);
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                toast.error(result?.message);
                setShowOverlay(false);
            }
        } catch (err) {
            var errorMessage = err?.response?.data?.message;
            toast.error(errorMessage);
            setShowOverlay(false);
        }
    }

    const toggleHomeOption = (value) => {
        setOption(value)

    }
    useEffect(() => {
        fetData()
        enableData()
        enableMobileData()
    }, [withOutRefresh])
    return (
        <div className='px-2 px-md-0'>
            {showOverlay && (<Response_Processing></Response_Processing>)}
            <h4 className="admin-title mb-4 theme-text-color text-md-start ">
                <MessageBox text="Movie Page Menu Settings" classname="theme-text-color" />
            </h4>
            {/* <div className='d-flex align-items-center justify-content-center gap-4 pb-5'>
                <button onClick={() => toggleHomeOption('web')} className={`${option == "web" && 'active'} bg-transparent orderTitle position-relative`}><MessageBox text="Web Home Page" /></button>
                <button onClick={() => toggleHomeOption('mobile')} className={`${option == "mobile" && 'active'} bg-transparent orderTitle position-relative`}><MessageBox text="Mobile Home Page" /></button>
            </div> */}
            {option == "web" &&
                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                    {enableSetting?.map((item) => {
                        return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                            <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                <MessageLabel text={item?.header_name?.length > 20 ? `${item.header_name.substring(0, 20)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                <AdminSwitch name={item?.name} checked={item?.Web_HomePage_status} onChange={() => handleToggleSettings(item?.name, item?.Web_HomePage_status)} />
                            </div>
                        </div>
                    })}
                    <div className='col-12 text-end mt-3'>
                        <AdminCustomButton saveMethod={updateSetting} saveText="Save Setting" />
                    </div>
                </div>}
            {option == "mobile" &&
                <div className="row align-items-center theme-bg-color rounded-2 p-3">
                    {enableSettingMobile?.map((item) => {
                        return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                            <div className='d-flex align-items-center justify-content-between'>
                                <MessageBox text={item?.header_name} classname="theme-text-color" />
                                <label className="switch">
                                    <input name={item?.name} onChange={() => handleToggleSettingsMobile(item?.name, item?.Mobile_Homesetting_status)} checked={item?.Mobile_Homesetting_status} type="checkbox" />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                        </div>
                    })}
                    <div className='col-12 text-end'>
                        <AdminCustomButton saveMethod={updateSettingMobile} saveText="Save Setting" />
                    </div>
                </div>}
            <h4 className="admin-title mb-4 theme-text-color text-md-start">
                <MessageBox text="Order Movie" classname="theme-text-color" />
            </h4>
            <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                <div className="">
                    <div className="row m-0 theme-border-bottom-secondary pb-3">
                        <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"># </label> </div>
                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6">Name</label></div>
                        <div className="col-5 "><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>
                    </div>
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="menu-items" className="theme-bg-color"   >
                            {(provided) => (
                                <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color list-unstyled m-0 p-0">
                                    {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                                        apiData?.map((item, index) => (
                                            <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                {(provided) => (
                                                    <li ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  orderborder ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary`} >
                                                        <div className="row m-0 p-0 align-items-center">
                                                            <div className="col-2  category-order-title">
                                                                <div className='d-flex position-relative '>
                                                                    <p className="theme-text-color mb-3 admin-input-title d-block position-relative"> {item?.order_id} </p>
                                                                </div>
                                                            </div>
                                                            <div className="col-5  category-order-title">
                                                                <MessageLabel text={item?.header_name?.length > 20 ? `${item.header_name.substring(0, 20)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                                            </div>
                                                            <div className="col-5  category-order-title">
                                                                <div className="editdropdown">
                                                                    <span className="editdropdown-button">
                                                                        <span>
                                                                            <FaEllipsisVertical className="theme-text-color" />
                                                                        </span>
                                                                    </span>
                                                                    <div className="editdropdown-menu theme-bg-color">
                                                                        <Link to={`/edit-movie-order/${item?.id}`} className="theme-text-color  theme-bg-color">
                                                                            <span>
                                                                                <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                                                <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                                                            </span>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </Draggable>
                                        ))}
                                </ul>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            </div>
        </div>

    )
}

export default MovieSettings